import { Component, Input, OnChanges, Output, EventEmitter, OnInit } from '@angular/core';
import { SmallshiService } from '../../services/smallshi.service';
import { Productos } from '../clases/productos';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { alfreditoService } from '../../services/task-alfredito.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { CarritoControlerService } from 'src/app/services/carrito-controler.service';


@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  template: ``
})
export class ProductsComponent implements OnChanges, OnInit {
  nuevosProductos: any[] = [];
  productosX: Productos[] = [];
  enviroment = environment;
  loading = false;
  @Input() categoriaInput = '';
  @Input() idComercio = '';
  @Output() finalizarPedido: EventEmitter<boolean>;
  @Input() etiquetasCom = '';
  @Input() salesCode = '';
  @Input() ecomerce = '';
  @Input() nombre_tienda = '';
  @Input() rnc = '';
  @Input() cedula = '';
  datosTienda
  indCarrito = false;
  numProductos = 0;
  valorFactura = 0;
  finalizar: boolean = false;
  error = false;
  environment = environment;
  loadingProducts: boolean = false;
  // Variables del modal
  indexM = 0;
  orange = 'rgba(255, 255, 255, 1);';
  constructor(private small: SmallshiService,
    private modal: NgbModal,
    private alfreditoService: alfreditoService,
    private carritoControlerService: CarritoControlerService) {
    this.finalizarPedido = new EventEmitter;
  }
  ngOnChanges() {
    this.getProducts(this.idComercio, this.categoriaInput, this.etiquetasCom, this.salesCode);
  }

  ngOnInit(): void {
    this.small.getDatosTienda$.subscribe(res => {
      this.datosTienda = res['data'];
    })
  }

  toggleCarrito(state: boolean) {
    this.carritoControlerService.closeCarrito(state)
  }

  validarProductos() {
    if (this.nuevosProductos) {
      for (let element of this.nuevosProductos) {
        if (Number(element.controlstock) == 0) {
          const prod: Productos =
          {
            product_id: '',
            category_id: '',
            title: '',
            price: 0,
            cantidad: 0,
            description: '',
            imagenes: [],
            impuesto_id: '',
            impuesto_porcentaje: 0,
            priceConImpuesto: 0,
            controlStock: 0,
            stock: 0,
            alert: 0,
            isVisible: false
          };
          prod.product_id = element.product_id;
          prod.category_id = element.category_id;
          prod.title = element.title;
          prod.price = element.price;
          prod.cantidad = 0;
          prod.description = element.description;
          prod.imagenes = element.imagenes;
          prod.impuesto_id = element.impuesto.id;
          prod.impuesto_porcentaje = element.impuesto.porcetanje;
          prod.priceConImpuesto = Number(element.price) + ((element.impuesto.porcetanje * element.price) / 100);
          prod.controlStock = parseInt(element.controlstock);
          prod.stock = parseInt(element.stock);
          prod.isVisible = true;
          this.validateProdX(prod);
        } else {
          // if (Number(element.controlstock) == 1 && Number(element.stock) != 0) {

            const prod: Productos = { product_id: '', category_id: '', title: '', price: 0, cantidad: 0, description: '', imagenes: [], impuesto_id: '', impuesto_porcentaje: 0, priceConImpuesto: 0, controlStock: 0, stock: 0, alert: 0, isVisible: false };
            prod.product_id = element.product_id;
            prod.category_id = element.category_id;
            prod.title = element.title;
            prod.price = element.price;
            prod.cantidad = 0;
            prod.description = element.description;
            prod.imagenes = element.imagenes;
            prod.impuesto_id = element.impuesto.id;
            prod.impuesto_porcentaje = element.impuesto.porcetanje;
            prod.priceConImpuesto = Number(element.price) + ((element.impuesto.porcetanje * element.price) / 100);
            prod.controlStock = parseInt(element.controlstock);
            prod.stock = parseInt(element.stock);
            prod.isVisible = true;
            this.validateProdX(prod);

          // }
        }


      }
    }

  }

  async getProducts(idComercio, idCategoria, etiquetas: string, salesCode: string) {
    try {
      if (this.loadingProducts) return;
      this.loadingProducts = true;
      this.loading = true;
      this.nuevosProductos = <any>(await this.small.getProducts(idComercio, idCategoria, etiquetas, salesCode).toPromise());
      if (Object.keys(this.nuevosProductos).length === 0) return
      this.nuevosProductos = this.nuevosProductos['data']['productos']
      this.visibleFalse();
      this.loading = false;
      this.validarProductos();

      if (this.enviroment.options.isHotel) await this.listarTareas();
      this.loadingProducts = false;
    } catch (error) {
      console.log('error al cargar los datos de productos ', error);
      this.loadingProducts = false;
    }

  }


  async listarTareas() {

    try {
      if (!this.nuevosProductos) return;
      const productosAlfredito = (await this.alfreditoService.getListadoTareas().toPromise())['data'];
      for (const productoSmallshi of this.nuevosProductos) {
        const existInAlfredito = productosAlfredito.some(productoAlfredito => productoSmallshi.product_id == productoAlfredito.id_smallshi)
        if (!productoSmallshi.description) productoSmallshi.description = "No hay descripción disponible"
        if (existInAlfredito) continue;

        const categoria = this.alfreditoService.reviewCategory(productoSmallshi.nmcategoria);
        const body = {
          nombre: (productoSmallshi.title.length < 30) ? productoSmallshi.title : productoSmallshi.title.substring(0, 29),
          descripcion: productoSmallshi.description,
          inspector_id: this.environment.options.inspector_id,
          categoria: categoria,
          id_smallshi: productoSmallshi.product_id,
          tiempo: this.enviroment.options.tiempo
        }
        await this.alfreditoService.crearTipoTarea(body).toPromise();
      }
    } catch (error) {
      console.error('%c No se ha podido cargar las tareas de alfredito')
      console.log(error)
    }
  }

  crearTipoTarea(nombre: string, descripcion: string, inspector_id: number, categoria: string, id_smallshi, tiempo: number) {
    let body = { nombre, descripcion, inspector_id, categoria, id_smallshi, tiempo }
    this.alfreditoService.crearTipoTarea(body).subscribe(res => { console.log(res) })
  }



  agregarProducto(idx: number, signo: boolean) {
    if (!signo) {
      if (this.productosX[idx].cantidad > 0) {
        this.productosX[idx].cantidad = this.productosX[idx].cantidad - 1;
      } else {
        //console.log('no puede ser menor a 0');
        this.orange = 'rgba(241, 91, 38, 0.4);';
      }
    } else {
      if (this.productosX[idx].controlStock == 1) {
        if (this.productosX[idx].stock == 0) {
          //console.log('No se puede agregar al carrito');
          this.productosX[idx].alert = 1;
        } else {
          if (this.productosX[idx].stock > this.productosX[idx].cantidad) {
            this.productosX[idx].cantidad = this.productosX[idx].cantidad + 1;
          } else {
            this.productosX[idx].alert = 1;
          }
        }
      } else {
        this.productosX[idx].cantidad = this.productosX[idx].cantidad + 1;
      }


    }
    this.carritoDatos();
    this.indCarrito = true;
  }
  carritoDatos() {
    this.numProductos = 0;
    this.valorFactura = 0;
    for (let prodCarrito of this.productosX) {
      this.numProductos = prodCarrito.cantidad + this.numProductos;
      this.valorFactura = (prodCarrito.cantidad * prodCarrito.price) + this.valorFactura;
    }
  }
  openModal(idx: number, contenido) {
    this.indexM = idx;
    this.modal.open(contenido);
  }
  verMas(txt) {
    if (txt.length > 16) {
      return txt.substring(0, 16);
    } else return txt;
  }

  validateProdX(x: Productos) {
    if (this.productosX.length > 0) {
      let indexProX = false;
      for (let y = 0; y < this.productosX.length; y++) {
        if ((this.productosX[y].product_id === x.product_id) && (this.productosX[y].category_id === x.category_id)) {
          indexProX = true;
          this.productosX[y].isVisible = true;
        }
      }
      if (!indexProX) {
        this.productosX.push(x);
      }
    } else {
      this.productosX.push(x);
    }
  }
  visibleFalse() {
    this.productosX.forEach(element => {
      element.isVisible = false;
    });
  }
  cerrarCatalogo(flagFinalizacion: boolean) {
    this.finalizarPedido.emit(flagFinalizacion);
  }
}
